class JackCustomGuide extends HTMLElement {
    static CACHE = new Map();
    static CACHE_LIMIT = 10;
    constructor() {
      super();
      this.url = this.dataset.url + '?section_id=helper-page-content';
      this.addEventListener('click', e => { e.preventDefault(); this.show(); });
      this.init();
    }
    cacheContent(u, c) {
      JackCustomGuide.CACHE.set(u, c);
      if (JackCustomGuide.CACHE.size > JackCustomGuide.CACHE_LIMIT)
        JackCustomGuide.CACHE.delete(JackCustomGuide.CACHE.keys().next().value);
    }
    getCachedContent(u) { return JackCustomGuide.CACHE.get(u) || null; }
    init() {
      if (!document.querySelector('custom-guide')) {
        const guide = document.createElement('custom-guide'),
              l = `<custom-guide-loader class="button--loader"><span class="button__preloader"><svg class="button__preloader-element" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke-width="4"></circle></svg></span><span class="button__preloader-text">Loading content...</span></custom-guide-loader>`,
              c = `<custom-guide-close><span class="visually-hidden">Close sidebar</span><span aria-hidden="true" aria-role="img"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 1L1 17" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M1 1L17 17" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></custom-guide-close>`,
              cnt = `<custom-guide-content></custom-guide-content>`;
        guide.innerHTML = l + `<custom-guide-wrapper>${c}${cnt}</custom-guide-wrapper>`;
        document.body.appendChild(guide);
      }
      this.popup = document.querySelector('custom-guide');
      this.loader = this.popup.querySelector('custom-guide-loader');
      this.close = this.popup.querySelector('custom-guide-close');
      this.content = this.popup.querySelector('custom-guide-content');
      this.popup.addEventListener('click', e => { if (e.target.classList.contains('active')) this.hide(); });
      this.close.addEventListener('click', () => this.hide());
    }
    show() {
      this.popup.classList.add('active');
      [this, this.popup, this.loader].forEach(el => el.classList.add('working'));
      this.fetchContent(this.url);
    }
    hide() {
      this.classList.remove('working');
      this.popup.classList.remove('active', 'working', 'loaded');
    }
    async fetchContent(u) {
      let txt = this.getCachedContent(u);
      if (txt) { this.renderContent(txt); return this._done(); }
      try {
        const res = await fetch(u);
        txt = await res.text();
        this.cacheContent(u, txt);
        this.renderContent(txt);
      } catch (e) { console.error('Error fetching content:', e); }
      this._done();
    }
    renderContent(t) { this.content.innerHTML = t; }
    _done() {
      [this, this.popup, this.loader].forEach(el => el.classList.remove('working'));
      this.popup.classList.add('loaded');
      this.content.querySelectorAll('.rte a img').forEach(i => i.parentNode.style.border = 'none');
      this.content.querySelectorAll('.rte table').forEach(t => 
        t.outerHTML = `<div class="table-wrapper">${t.outerHTML}</div>`
      );
    }
  }
  customElements.define('jack-custom-guide', JackCustomGuide);